import { Tag, Text } from '@moia-dev/pace-web'

export const TenantSection = ({
  label,
  tenants,
}: {
  label: string
  tenants: string[]
}) => {
  return (
    <div
      css={theme => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.space.Space2,
      })}
    >
      <Text>{label}</Text>
      <div
        css={theme => ({
          display: 'flex',
          gap: theme.space.Space1,
          flexWrap: 'wrap',
        })}
      >
        {tenants?.length > 0 ? (
          tenants.map(tenant => <Tag key={tenant} label={tenant} />)
        ) : (
          <Text size="md">-</Text>
        )}
      </div>
    </div>
  )
}
